import type { UUID, ISODateString } from './common';

export const CARPET_PRICING_CATEGORIES = [
  'service_tier',
  'stairs',
  'hallways',
  'rooms',
  'extras',
  'surcharges',
] as const;
export type CarpetPricingCategory = (typeof CARPET_PRICING_CATEGORIES)[number];

export interface CarpetPricingCatalogItem {
  id: UUID;
  key: string;
  label: string;
  category: CarpetPricingCategory;
  defaultRate: number;
  pricingMode: 'qty_rate' | 'amount';
  unitLabel: string | null;
  sortOrder: number;
  createdAt: ISODateString;
  updatedAt: ISODateString;
}

export const CARPET_KEY_REGEX = /^carpet_[a-z0-9_]+$/;
